module.exports = __webpack_public_path__ + "static/og-9617ce6ddae776585a663f3135d05c28.png";